export const FB_PAGE_PREDEFINED_ATTRIBUTES = [
  'UNSUBSCRIBED',
  'WPSUBSCRIBED',
  'EMAIL',
  'PHONE',
  'MESSENGER_AD_ANSWER',
];

export default interface AttributeModel {
  id: number;
  name: string;
  system?: boolean;
  settable?: boolean;
  webhooksOnly?: boolean; // webhooksOnly vars are intended only for usage
  friendlyName?: string;
  value?: string | number | null;
}
